import Header from './components/Header';
import HeroSection from './components/HeroSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <IndexSection />
        <CardsSection />
        <AppSection />
        <RankingSection />
        <FeaturesSection />
        <CommentsSection />
        <UpdatesSection />
        <AboutSection />
        <CarouselSection />
        <ContactSection />
        <TopicsSection />
        <MediaSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}